import CryptoJS from 'crypto-js'//哈希值

//业务ID
export function randomHexString (){
  return Math.random().toString(16).slice(2)
}

//随机字符串
export function randomString (length){
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  let result = ''
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return result
}

// 生成签名值
export function generateSign (params, key) {
  // 将非空参数值按照参数名的 ASCII 码从小到大排序，并使用 URL 键值对的格式拼接成字符串 stringA
  const paramsList = []
  for (const key in params) {
    if (Object.prototype.isPrototypeOf.call(params, key) && params[key]) {
      paramsList.push(`${key}=${params[key]}`)
    }
  }
  paramsList.sort()
  const stringA = paramsList.join('&')
  // 在 stringA 的末尾拼接上 key，得到字符串 stringSignTemp
  const stringSignTemp = stringA + '&key=' + key
  console.log(stringSignTemp);
  // 对 stringSignTemp 进行 MD5 运算，得到签名值 signValue
  const signValue = CryptoJS.MD5(stringSignTemp).toString().toUpperCase()
  return signValue
}